import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { SUBSCRIBE } from '../api';

export default {
    namespaced: true,
    state: {
        create: request_state(),
    },
    mutations: request_mutations('create_subscriber', 'create'),
    actions: {
        create({ commit }, { email }) {
            commit('create_subscriber_loading');
            return new Promise((resolve) => {
                axios.post(SUBSCRIBE, { email }).then((response) => {
                    commit('create_subscriber_success', response.data);
                    resolve();
                }).catch(error => commit('create_subscriber_error', error.response ? error.response.data : {}));
            });
        },
    },
};
